import { useTranslation } from 'react-i18next'

import { useContentOverflow } from '../../../../hooks'
import { FloatingTooltip } from '../../../Floating'
import Text from '../../../Text'
import { getRequestPhaseAsyncMultiValuedListItemStatusText } from '../RequestPhaseAsyncMultiValuedList.utils'

import * as styles from './RequestPhaseAsyncMultiValue.module.css'

function RequestPhaseAsyncMultiValue({
  className = styles.RequestPhaseAsyncMultiValue,
  name,
  progress,
  ...restProps
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const statusText = getRequestPhaseAsyncMultiValuedListItemStatusText({
    progress,
    t,
  })

  return (
    <div {...restProps} className={className}>
      <FloatingTooltip content={name} disabled={!overflow}>
        <Text ref={setContentOverflowRef}>{name}</Text>
      </FloatingTooltip>
      <Text isSecondary className={styles.status}>
        {statusText}
      </Text>
    </div>
  )
}

export default RequestPhaseAsyncMultiValue
